import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from 'lodash';
import {IAnswer, IQuestion, IYear} from "../../../../../data/data";
import {VoiceOver} from "../../../../common/VoiceOver";
import {hideModal, showGameOverModal} from "../../../../../store/actions/modals";
import HighlightText from "../../../../common/highlight-text/HighlightText";
import Button from "../../../../common/ui/button/Button";
import YearEndSummary from './YearEndSummary';
import {getYearEndQuestionData} from '../../../../../store/reducers/questions/yearEndQuestion';
import {incrementYear} from '../../../../../store/actions/calendar/year';
import {recordCorrectAnswer} from '../../../../../store/actions/questions/questions';
import {getYearData} from '../../../../../store/reducers/year';
import {setScreen} from '../../../../../store/actions/screens';
import {SCREENS} from '../../../../../store/reducers/screen';

interface QuestionProps
{
    question: IQuestion;
    year: IYear;
    incrementYear: () => void;
    hideModal: () => void;
    closeModal: () => void;
    recordCorrectAnswer: () => void;
    showGameOverModal: () => void;
}

interface QuestionState
{
    answer: number;
    answered: boolean;
    width: number;
    height: number;
}

import * as styles from './Question.scss';

const initial_state: QuestionState =
    {
        answer: null,
        answered: false,
        width: null,
        height: null,
    };

class YearEndQuestion extends React.Component<QuestionProps, QuestionState>
{
    constructor(public props: QuestionProps, public state: QuestionState)
    {
        super(props);

        this.state = initial_state;
    }


    measureEl = (el: HTMLElement, answered: boolean) =>
    {
        const {answered:sanswered, height:oheight, width:owidth} = this.state;

        if (sanswered !== answered) return;

        if (! el) return;

        const {width:nwidth, height:nheight} = el.getBoundingClientRect();

        if (owidth !== nwidth || oheight !== nheight) this.setState({ width: nwidth, height: nheight });
    };


    /**
     * get response options for the question
     * @returns {JSX.Element[]}
     */
    getOptions = () : JSX.Element[] =>
    {
        return _.map(this.props.question.answers, (answer: IAnswer, i: number) =>
        {
            return <VoiceOver
                vo={answer.vo}
                style_name={styles.option}
                onClick={() => this.chooseAnswer(i)}
                key={i}>

                {answer.text}

            </VoiceOver>;
        });
    };


    chooseAnswer = (answer: number) =>
    {
        this.setState({ answer: answer, answered: true });

        //TODO  do we want to display a response here for either correct/incorrect/both answers?

        const is_correct: boolean = answer === this.props.question.answer;

        if (is_correct)
        {
            const {recordCorrectAnswer} = this.props;

            recordCorrectAnswer();
        }

        // if (answer === this.props.question.answer) this.props.clearOutageID();
        //
        // this.props.hideModal();
    };


    incrementYear = () =>
    {
        const {incrementYear, closeModal, hideModal} = this.props;

        hideModal();
        closeModal();

        _.delay(() => incrementYear(), 500);
    };


    getCorrectText = () =>
    {
        const options: string[] =
            [
                "That’s right – well done!",
                "Woohoo – that’s correct!",
                "Yes! That’s the right answer – well done!",
                "You got it right!",
                "Correct – hooray!",
                "Well done – good choice",
                "You got it – well done!",
                "Good choice – correct!",
                "Correct! Good thinking",
                "You were paying attention – that’s the right answer",
            ];

        return _.sample(options);
    };


    getIncorrectText = () =>
    {
        const options: string[] =
            [
                "Sorry – that’s the wrong answer",
                "Uh-oh… That’s not right",
                "That’s the wrong answer – remember to listen out for the answer at the start of each challenge",
                "Oh dear – remember to look out for the answer at the start of the challenge",
                "Bad luck – that’s the wrong answer",
                "Oh dear – that’s not right. Don't forget to listen carefully for the answer at the start of each challenge.",
                "Uh-oh… That’s not the right answer",
                "Oh no – that’s not the right answer",
                "Uh-oh – that’s not right",
                "Sorry, that’s not the right answer",
            ];

        return _.sample(options);
    };


    render()
    {
        const {question, year, showGameOverModal} = this.props;
        const {answer, answered, width, height} = this.state;

        if (! question) return null;

        const {question:question_text, image, response, answers, answer:correct_answer} = question;
        // const {affects} = outage;
        const affects: string = null;
        const is_correct: boolean = answer === this.props.question.answer;

        return <div styleName={! answered ? 'question-content' : 'answer-content'}>

            {/*<div styleName={'header'}>

                <div styleName={'image'}>

                    <img
                        styleName={'source-image'}
                        src={`./img/game/power-sources/${affects}@2x.png`} />
                    <img
                        styleName={'warning-icon'}
                        src={`./img/game/modals/warning-icon@2x.png`} />

                </div>

            </div>*/}

           {/* <div styleName={'warning'}>

                <p styleName={'warning-text'}><span styleName={'warning-attention'}>attention action needed - </span>Answer a questions to fix your power stations and bring them back online</p>


                <p>answer the question to progress to the next year</p>

                <YearEndSummary />

            </div>*/}

            <div
                styleName={'question-and-answer'}
                style={{ width, height }}>

                <div
                    styleName={'question-slide'}
                    ref={el => this.measureEl(el, false)}>

                    <HighlightText type={'green'}>question</HighlightText>

                    <h4 styleName={'headline'}>{question_text}</h4>

                    {/*<p styleName={'body-copy'}>{question_text}</p>*/}

                    <div styleName={'options'}>

                        {this.getOptions()}

                    </div>
                </div>

                <div
                    styleName={'answer-slide'}
                    style={{ pointerEvents: answered ? 'auto' : 'none' }}
                    ref={el => this.measureEl(el, true)}>

                    {/*<HighlightText type={is_correct ? 'green' : 'red'}>{is_correct ? 'well done!' : 'wrong answer!'}</HighlightText>*/}

                    <p styleName={'label'} style={{ color: is_correct ? '#396518' : '#E04C00' }}>{is_correct ? this.getCorrectText() : this.getIncorrectText()}</p>

                    {/*<h4 styleName={'headline'}>{question_text}</h4>*/}

                    {/*<p styleName={'body-copy'}>{question_text}</p>*/}

                    {! is_correct &&
                    <div styleName={'response'}>

                        <p>The correct answer is: <b>{answers[correct_answer].text}</b></p>

                    </div>}

                    {year.year !== 2031 &&
                    <div styleName={'answer-footer'}>

                        {is_correct &&
                        <Button
                            type={'right-answer'}
                            onClick={this.incrementYear}>

                            next challenge

                        </Button>}

                        {! is_correct &&
                        <Button
                            type={'right-answer'}
                            onClick={this.incrementYear}>

                            next challenge

                        </Button>}

                    </div>}

                    {year.year === 2031 &&
                    <div styleName={'answer-footer'}>

                        {is_correct &&
                        <Button
                            type={'right-answer'}
                            onClick={showGameOverModal}>

                            see how you did

                        </Button>}

                        {! is_correct &&
                        <Button
                            type={'right-answer'}
                            onClick={showGameOverModal}>

                            see how you did

                        </Button>}

                    </div>}

                </div>

            </div>

        </div>;
    }
}



const mapStateToProps = state =>
{
    return {
        question: getYearEndQuestionData(state),
        year: getYearData(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        incrementYear: () => dispatch(incrementYear()),
        hideModal: () => dispatch(hideModal()),
        closeModal: () => dispatch(setScreen(SCREENS.GAME)),

        recordCorrectAnswer: () => dispatch(recordCorrectAnswer()),
        showGameOverModal: () => dispatch(showGameOverModal()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(YearEndQuestion);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/event-question/YearEndQuestion.tsx